
















import Vue from 'vue'

export default Vue.extend({
  props: {
    columns: {
      type: Array,
      default: () => ([])
    },
    dataValue: {
      type: Array,
      default: () => ([])
    },
    index: {
      type: Number,
      default: null
    },
  },
  data(){
    return {
      tableColumns: [],
      tableData: [],
      standardEfficiency: null
    }
  },
  mounted(){
    this.initTableColumns()
  },
  methods:{
    initTableColumns(){
      this.tableColumns = []
      // console.log(11111111,this.dataValue, this.columns)
      if(this.dataValue.length > 1){
        const item = {
          title: this.$t('page_operation_statistics_workstationname'),
          dataIndex: 'title',
          key: 'title',
          width: 100,
          scopedSlots: { customRender: 'personal' }
        }
        this.tableColumns.push(item)
      }
      this.columns.forEach(item => {
        const value = {
          title: item.title,
          dataIndex: item.code,
          key: item.code,
          width: 100,
          scopedSlots: { customRender: 'personal' }
        }
        this.tableColumns.push(value)
        console.log(2,value)
      });
      this.initTableData()
    },
    initTableData(){
      this.tableData = []
      this.dataValue.forEach(item => {
        this.standardEfficiency = item.standardEfficiency
        const value = {
          title: item.workStationName
        }
        Object.keys(item.data).forEach(function(key){
          const numb = item.data[key] * 100
          value[key] = numb.toFixed(2) + '%'
        });
        this.tableData.push(value)
        console.log(4,this.tableData)
      });
    }
  }
})

